import { createFeature, createReducer, on } from '@ngrx/store';
import { ReviewBoardListItem, ReviewBoardStatusResponse } from '@models/review-board.model';
import { ReviewBoardActions } from '@store/actions/review-board/review-board.actions';

export const reviewBoardFeatureKey = 'reviewBoard';

export interface State {
  list: ReviewBoardListItem[];
  isListLoading: boolean;
  status: ReviewBoardStatusResponse | null;
  isStatusLoading: boolean;
  isSaving: boolean;
  error: string | null;
}

export const initialState: State = {
  list: [],
  isListLoading: false,
  status: null,
  isStatusLoading: false,
  isSaving: false,
  error: null,
};

export const reducer = createReducer(
  initialState,

  on(ReviewBoardActions.loadList, (state) => ({
    ...state,
    isListLoading: true,
    error: null,
  })),
  on(ReviewBoardActions.loadListSuccess, (state, { items }) => ({
    ...state,
    list: items,
    isListLoading: false,
    error: null,
  })),
  on(ReviewBoardActions.loadListFailure, (state, { error }) => ({
    ...state,
    isListLoading: false,
    error,
  })),

  on(ReviewBoardActions.loadStatus, (state) => ({
    ...state,
    status: null,
    isStatusLoading: true,
    error: null,
  })),
  on(ReviewBoardActions.loadStatusSuccess, (state, { status }) => ({
    ...state,
    status,
    isStatusLoading: false,
    error: null,
  })),
  on(ReviewBoardActions.loadStatusFailure, (state, { error }) => ({
    ...state,
    isStatusLoading: false,
    error,
  })),

  on(ReviewBoardActions.requestReview, (state) => ({
    ...state,
    isSaving: true,
    error: null,
  })),
  on(ReviewBoardActions.requestReviewSuccess, (state, { status }) => ({
    ...state,
    status,
    isSaving: false,
    error: null,
  })),
  on(ReviewBoardActions.requestReviewFailure, (state, { error }) => ({
    ...state,
    isSaving: false,
    error,
  })),

  on(ReviewBoardActions.cancelReview, (state) => ({
    ...state,
    isSaving: true,
    error: null,
  })),
  on(ReviewBoardActions.cancelReviewSuccess, (state, { status }) => ({
    ...state,
    status,
    isSaving: false,
    error: null,
  })),
  on(ReviewBoardActions.cancelReviewFailure, (state, { error }) => ({
    ...state,
    isSaving: false,
    error,
  })),
);

export const reviewBoardFeature = createFeature({
  name: reviewBoardFeatureKey,
  reducer,
});
